import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IDeleteFn, ITrainingType, IGetPutRequest } from '../../interfaces'

const getToggleActiveTrainingTypeMutationRequest: IGetPutRequest = params => {
  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingTypes/`,
  }
}

const useToggleActiveTrainingTypeMutation: IUseUpdateMutation<ITrainingType, number> = (params, options = {}) => {
  const request = useMemo(() => getToggleActiveTrainingTypeMutationRequest(params), [params])

  const updateTraining: IDeleteFn<ITrainingType> = useCallback(
    async id => axios({ ...request, url: request.url + id + '/toggle-is-active' }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingType, Error, any>({ mutationFn: updateTraining, ...options })

  return response
}

export default useToggleActiveTrainingTypeMutation
